export const SET_CALIBRATION_HOMEPAGE_MESSAGE = 'SET_CALIBRATION_HOMEPAGE_MESSAGE'



// WEBPACK FOOTER //
// ./src/store/modules/notificationmessage/types.js